export default __webpack_public_path__ + "static/media/logo.7797f6ff.png";